import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "template"]

    // Called from quotation-lines-row#openBomModal
    openFromRow(rowEl) {
        this.contentTarget.innerHTML = "";

        const hiddenBlocks = rowEl.querySelectorAll("[data-bom-hidden]");

        const existing = Array.from(hiddenBlocks)
            .map((block) => {
                const destroy = block.querySelector("[data-bom-hidden-destroy]")?.value;
                if (destroy === "1") return null;

                const id = block.querySelector("input[name$='[id]']")?.value; // existing DB id
                const bomProductId = block.querySelector("[data-bom-hidden-product-id]")?.value;
                const qty = block.querySelector("[data-bom-hidden-qty]")?.value;

                if (!bomProductId) return null;
                return { id: id || null, bomProductId: String(bomProductId), qty: qty || "1" };
            })
            .filter(Boolean);

        if (existing.length === 0) {
            this.addLine();
        } else {
            existing.forEach((line) => this.addLine(line));
        }

        this.element.classList.remove("hidden");
        this.element.classList.add("flex");
    }

    addLine({ id = null, bomProductId = null, qty = "1" } = {}) {
        this.contentTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML);

        const row = this.contentTarget.querySelector("[data-bom-line]:last-child");
        if (!row) return;

        if (id) row.dataset.bomLineId = String(id);

        const select = row.querySelector("select[data-price]");
        const qtyInput = row.querySelector("[data-quantity]");

        if (qtyInput) qtyInput.value = qty;
        if (select && bomProductId) select.value = bomProductId;
    }

    removeLine(event) {
        event.preventDefault()
        event.target.closest("[data-bom-line]")?.remove()
    }

    applyBom() {
        const rowId = this.element.dataset.rowId;
        const rowEl = document.getElementById(rowId);
        if (!rowEl) return;

        const bomFields = rowEl.querySelector("[data-bom-fields]");
        const container = bomFields?.querySelector("[data-bom-fields-container]");
        const template  = bomFields?.querySelector("[data-bom-fields-template]");
        if (!container || !template) return;

        // capture existing IDs before we wipe container
        const existingIds = Array.from(container.querySelectorAll("input[name$='[id]']"))
            .map((i) => i.value)
            .filter((v) => v && v !== "");

        container.innerHTML = "";

        let total = 0;
        let key = 0;

        const keptIds = new Set();

        // Build kept/new lines
        this.contentTarget.querySelectorAll("[data-bom-line]").forEach((uiRow) => {
            const select = uiRow.querySelector("select[data-price]");
            const bomProductId = select?.value;
            const price = parseFloat(select?.selectedOptions?.[0]?.dataset.price || 0);
            const qty = parseFloat(uiRow.querySelector("[data-quantity]")?.value || 0);

            if (!bomProductId || qty <= 0) return;

            total += price * qty;

            const html = template.innerHTML.replaceAll("NEW_RECORD", String(key++));
            const wrap = document.createElement("div");
            wrap.innerHTML = html;

            // if this UI row came from an existing DB record, keep its id
            const existingId = uiRow.dataset.bomLineId;
            if (existingId) {
                keptIds.add(existingId);
                wrap.querySelector("[data-bom-hidden-id]").value = existingId;
            }

            wrap.querySelector("[data-bom-hidden-product-id]").value = bomProductId;
            wrap.querySelector("[data-bom-hidden-qty]").value = qty;
            wrap.querySelector("[data-bom-hidden-destroy]").value = "0";

            container.appendChild(wrap.firstElementChild);
        });

        // Add destroy entries for removed existing lines
        existingIds.forEach((id) => {
            if (keptIds.has(id)) return;

            const html = template.innerHTML.replaceAll("NEW_RECORD", String(key++));
            const wrap = document.createElement("div");
            wrap.innerHTML = html;

            wrap.querySelector("[data-bom-hidden-id]").value = id;
            wrap.querySelector("[data-bom-hidden-destroy]").value = "1";

            // bom_product_id / quantity not required for destroy; leave blank
            container.appendChild(wrap.firstElementChild);
        });

        const rowController = this.application.getControllerForElementAndIdentifier(rowEl, "quotation-lines-row");
        rowController?.applyBom(total);

        this.close();
    }

    close() {
        this.element.classList.add("hidden")
        this.element.classList.remove("flex")
        this.contentTarget.innerHTML = ""
    }
}
